import { z } from "zod";

export default z.object({
    _id: z.string().optional(),
    userId: z.string(), // Or your configured contextKey
    icon: z.string().optional(),
    title: z.string(),
    message: z.string(),
    action: z.string().optional(), // e.g., a route to navigate to
    read: z.boolean().default(false),
    timestamp: z.date(),
    category: z.string().default("user"),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});